import FileIconAdd from './FileIconAdd'

export default FileIconAdd
